import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { GET_RULE_META_CONFIG, GET_RULE_META_CONFIG_SUCCESS, GET_RULE_META_CONFIG_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* getRuleMetaDataConfig({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/meta-data`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_RULE_META_CONFIG_SUCCESS,
        payload: response?.data,
      });
    } else {
      const message = response?.response?.data?.message || `Failed to load rule configuration.`;
      cogoToast.error(message);
      yield put({
        type: GET_RULE_META_CONFIG_ERROR,
        payload: message,
      });
    }
  } catch (error) {
    cogoToast.error(`Failed to load rule configuration.`);
    yield put({ type: GET_RULE_META_CONFIG_ERROR, payload: error });
  }
}

export function* watchgetRuleMetaDataConfig() {
  yield takeEvery(GET_RULE_META_CONFIG, getRuleMetaDataConfig);
}

function* getRuleMetaDataConfigSaga() {
  yield all([fork(watchgetRuleMetaDataConfig)]);
}

export default getRuleMetaDataConfigSaga;
